import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "extraOptions",
  initialState: {
    accountDetailsModal: false,
    deviceSettingsModal: false,
  },
  reducers: {
    setAccountDetailsModal: (state, action) => {
      state.accountDetailsModal = action.payload;
    },
    setDeviceSettingsModal: (state, action) => {
      state.deviceSettingsModal = action.payload;
    },
  },
});

export const openMyEffice = () => async (dispatch, getState) => {};
export const openHome = () => async (dispatch, getState) => {};

export const { setAccountDetailsModal, setDeviceSettingsModal } = slice.actions;

export const selectAccountDetailsModal = (state) =>
  state.extraOptions.accountDetailsModal;
export const selectDeviceSettingsModal = (state) =>
  state.extraOptions.deviceSettingsModal;

export default slice.reducer;
